import { RootState } from "../../rootReducer";

export const selectIsDeletingStressCheck = (state: RootState) =>
  state.changeStress.loading;
export const selectDeleteErrorMessage = (state: RootState) =>
  state.changeStress.error;
export const changeStressDataResponse = (state: RootState) =>
  state.changeStress.changeStressResponse;
